<form class="dynamicform" [formGroup]="form" >
  @for (field of config; track field) {
    <ng-container dynamicField [config]="field" [group]="form">
    </ng-container>
  }
</form>
